import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import Countdown from "react-countdown";
import stl from "./CampaignModal.module.css";
import { useEffect, useState } from "react";
import {useLang} from "@/common/Contexts/LanguageContext";
import {useTranslation} from "@i18n";

const CampaignModal = ({
  modalName,
  doClose,
  campaignData,
  isPostModal,
  dataFromPost,
}) => {
  const { t } = useTranslation();
  const lang = useLang();
  const [tab, setTab] = useState(0);

  useEffect(() => {
    if (dataFromPost?.cash) {
      setTab(0);
    } else {
      setTab(1);
    }
  }, [dataFromPost]);

  return (
    <BottomSheetPopup blueCloseIcon show={modalName} onClose={() => doClose()}>
      {isPostModal ? (
        <div className={stl.tabsContainer}>
          <strong>
            {dataFromPost?.cash &&
              dataFromPost?.finance &&
              t("تفاصيل العروض", {
                ns: "web_common",
              })}

            {dataFromPost?.cash &&
              !dataFromPost?.finance &&
              t("عرض الكاش", {
                ns: "web_common",
              })}

            {!dataFromPost?.cash &&
              dataFromPost?.finance &&
              t("عرض التمويل", {
                ns: "web_common",
              })}
          </strong>
          {dataFromPost?.cash && dataFromPost?.finance && (
            <div className={stl.tabsHead}>
              {dataFromPost?.cash && (
                <div
                  className={tab == 0 ? stl.active : ""}
                  onClick={() => {
                    setTab(0);
                  }}>
                  💵{" "}
                  {t("عرض الكاش", {
                    ns: "web_common",
                  })}
                </div>
              )}
              {dataFromPost?.finance && (
                <div
                  className={tab == 1 ? stl.active : ""}
                  onClick={() => {
                    setTab(1);
                  }}>
                  🏦{" "}
                  {t("عرض التمويل", {
                    ns: "web_common",
                  })}
                </div>
              )}
            </div>
          )}
          <div
            className={stl.tabsContent}
            style={{
              transform:
                tab == 1
                  ? lang === "ar"
                    ? "translate(calc(100% + 20px), 0px)"
                    : "translate(calc(-100% - 20px), 0px)"
                  : undefined,
            }}>
            {(tab == 0 || true) && (
              <div>
                {dataFromPost?.cash && (
                  <>
                    {dataFromPost?.cash?.desktop_image && (
                      <img src={dataFromPost?.cash?.desktop_image} alt="img" />
                    )}

                    {dataFromPost?.counter_timestamp ? (
                      <div className={stl.countdownWrapper}>
                        <strong>
                          {t("باقي على العرض:", {
                            ns: "web_common",
                          })}
                        </strong>
                        <Countdown
                          date={
                            !dataFromPost?.finance
                              ? dataFromPost?.cash?.counter_timestamp * 1000
                              : dataFromPost?.counter_timestamp * 1000
                          }
                          daysInHours
                          onComplete={() => {}}
                          renderer={({ hours, minutes, seconds, days }) => (
                            <div className={stl.countdown}>
                              {days > 0 ? (
                                <>
                                  <strong>{days * 24} </strong>
                                </>
                              ) : (
                                <strong>
                                  {hours < 10 ? `0${hours}` : hours + days * 24}
                                </strong>
                              )}
                              :
                              <strong>
                                {minutes < 10 ? `0${minutes}` : minutes}
                              </strong>{" "}
                              :
                              <strong>
                                {seconds < 10 ? `0${seconds}` : seconds}
                              </strong>
                            </div>
                          )}
                        />
                      </div>
                    ) : null}

                    <h2>{dataFromPost?.cash?.text} </h2>
                    {dataFromPost?.cash?.description && (
                      <div
                        className={stl.description}
                        dangerouslySetInnerHTML={{
                          __html: dataFromPost?.cash?.description,
                        }}></div>
                    )}
                  </>
                )}
              </div>
            )}
            {(tab == 1 || true) && (
              <div>
                {dataFromPost?.finance && (
                  <>
                    {dataFromPost?.finance?.desktop_image && (
                      <img
                        src={dataFromPost?.finance?.desktop_image}
                        alt="img"
                      />
                    )}
                    <h2>{dataFromPost?.finance?.text}</h2>
                    {dataFromPost?.finance?.description && (
                      <div
                        className={stl.description}
                        dangerouslySetInnerHTML={{
                          __html: dataFromPost?.finance?.description,
                        }}></div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={stl.wrapper}>
          <strong>
            {modalName === "finance"
              ? t("عرض التمويل", {
                  ns: "web_common",
                })
              : t("عرض الكاش", {
                  ns: "web_common",
                })}
          </strong>
          <img src={campaignData?.desktop_image} alt="" />
          {campaignData?.counter_timestamp ? (
            <div className={stl.countdownWrapper}>
              <strong>
                {t("باقي على العرض:", {
                  ns: "web_common",
                })}
              </strong>
              <Countdown
                date={campaignData?.counter_timestamp * 1000}
                daysInHours
                onComplete={() => {}}
                renderer={({ hours, minutes, seconds, days }) => (
                  <div className={stl.countdown}>
                    {days > 0 ? (
                      <>
                        <strong>{days * 24} </strong>
                      </>
                    ) : (
                      <strong>
                        {hours < 10 ? `0${hours}` : hours + days * 24}
                      </strong>
                    )}
                    :<strong>{minutes < 10 ? `0${minutes}` : minutes}</strong> :
                    <strong>{seconds < 10 ? `0${seconds}` : seconds}</strong>
                  </div>
                )}
              />
            </div>
          ) : null}

          <h2>{campaignData?.text} </h2>

          <div
            className={stl.description}
            dangerouslySetInnerHTML={{
              __html: campaignData?.description,
            }}></div>

          {/* <p>{campaignData?.description}</p> */}
        </div>
      )}
    </BottomSheetPopup>
  );
};

export default CampaignModal;
